import React, { Component } from "react";
import "./CreateModal.styles.scss";
import EscapeOutside from "react-escape-outside";

import BounceLoader from "react-spinners/BounceLoader";
import FadeLoader from "react-spinners/FadeLoader";
import axios from "axios";

import picture from "./_image/picture.svg";
import close_green_corner from "./_image/close_green_corner.svg";
import close_button from "./_image/close_button.svg";
import Dropdown from "./Dropdown/Dropdown";
//import MomentUtils from "@date-io/moment";
import DateFnsUtils from "@date-io/date-fns";
//import moment from "moment";
import { format } from "date-fns";
import { store } from "react-notifications-component";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import districts from "./content/districts";
import divisions from "./content/divisions";
import { normalizeString } from "../utils/normalizeString";
import checkValidity from "../utils/validityCheckForSubmitting";
import { Collapse } from "@mui/material";
import { useNotification } from "../../../../../Notifications/NotificationProvider";

const userTags = [
  { name: "MMO", id: "1" },
  { name: "MAO", id: "2" },
];

// import { useNotification } from "../../../../../Notifications/NotificationProvider";

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <div className="wrapper-modal">
        <section className="modal-main">{children}</section>
      </div>
    </div>
  );
};

class ManageModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      spots: [],
      agency: [],
      areas: [],
      territories: [],
      regions: [],
      clusters: [],
      createdZone: {
        ...props.data,
      },
      errorMessages: [],
    };
  }

  componentDidMount() {
    //this.loadZonesForDropDown(this.props.selectedZone["parentId"]);
    // this.loadZonesForDropDown("agency");
    // this.loadZonesForDropDown("areas");
    // this.loadZonesForDropDown("territories");
    // this.loadZonesForDropDown("regions");
    // this.loadFSE()
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // console.log("hitttt");
    // if (
    //   JSON.stringify(nextProps.data) !== JSON.stringify(prevState.createdZone)
    // ) {
    //   return { createdZone: { ...nextProps.data } };
    // }

    if (
      nextProps.selectedZone["parentId"] &&
      prevState[nextProps.selectedZone["parentId"]].length === 0
    )
      return {
        [nextProps.selectedZone["parentId"]]:
          nextProps.zoneMapping[nextProps.selectedZone["parentId"]],
      };

    return null;
  }

  componentDidUpdate(prevProps) {
    //console.log(prevProps.data);
    // if (this.props.selectedZone["id"] !== prevProps.selectedZone["id"])
    //   this.loadZonesForDropDown(this.props.selectedZone["id"]);
  }

  handleZoneName = (e) => {
    // console.log(e.target.value);
    // console.log({ ...this.state.createdZone, name: e.target.value });
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        name: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleZoneCode = (e) => {
    //console.log(e.target.value);
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        code: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  handleZoneMAWallet = (e) => {
    //console.log(e.target.value);
    e.preventDefault();
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        ma_wallet: e.target.value,
      },
    });
    this.setState({ errorMessages: [] });
  };

  hideModal = () => {
    this.props.handleHide();
    this.setState({ createdZone: { ...this.props.data }, errorMessages: [] });
  };

  handleZone = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        [`${this.props.selectedZone["parentId"]}_id`]: e.id,
        [`${this.props.selectedZone["createParentId"]}_name`]: e.name,
      },
    });
    this.setState({ errorMessages: [] });
  };
  handleUserTagChange = (e) => {
    console.log(e);
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        user_tag: e.name,
      },
    });
    this.setState({ errorMessages: [] });
  };
  handleDistrictChange = (e) => {
    this.setState((prevState) => ({
      createdZone: {
        ...prevState.createdZone,
        district: e.target.value,
      },
    }));
    this.setState({ errorMessages: [] });
  };

  handleThanaChange = (e) => {
    this.setState((prevState) => ({
      createdZone: {
        ...prevState.createdZone,
        thana: e.target.value,
      },
    }));
    this.setState({ errorMessages: [] });
  };

  handleDivisionChange = (e) => {
    this.setState({
      createdZone: {
        ...this.state.createdZone,
        division: e.name,
      },
    });
    this.setState({ errorMessages: [] });
  };

  submitForCreating = () => {
    // const errorMsg = checkValidity(
    //   { ...this.state.createdZone },
    //   this.props.selectedZone["id"]
    // );

    if (
      this.props.selectedZone["id"] == "agency" &&
      this.state.createdZone["ma_wallet"] === ""
    ) {
      this.setState({ errorMessages: ["Please fill up the MA Wallet number"] });
      return;
    }

    const currentZone = this.state[this.props.selectedZone["parentId"]].find(
      (item) =>
        item.name === this.state.createdZone[this.props.selectedZone["parent"]]
    );
    const postObject =
      this.props.selectedZone["id"] === "regions"
        ? { ...this.state.createdZone }
        : {
            ...this.state.createdZone,

            [`${this.props.selectedZone["parentId"]}_id`]: currentZone.id,
          };

    delete postObject[this.props.selectedZone["children"]];

    this.setState({ loading: true });
    axios
      .put(
        `${process.env.REACT_APP_API_URL}/api/organizations/api/v1/${this.props.selectedZone["id"]}`,
        { ...postObject },
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        alert(
          `${normalizeString(this.props.selectedZone["createId"])} saved !`
        );
        console.log("success");
        this.setState({ loading: false });
        this.hideModal();
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
        this.hideModal();
      });
  };

  render() {
    return (
      <section className="mdocreate-section">
        <Modal show={this.props.show} handleClose={this.hideModal}>
          <div className="modal-header">
            <div className="headline">
              <div className="main-headline">
                Manage {normalizeString(this.props.selectedZone["createId"])}
              </div>
              <div className="sub-headline">Edit details and press Submit</div>
            </div>
            {/* <div className="close-button-corner" onClick={this.close_clear}>
              <img className="corner" src={close_green_corner} alt="close" />
              <img className="cross" src={close_button} alt="close" />
              <button className="button--close" onClick={this.props.handleHide}>
                X
              </button>
            </div> */}
          </div>
          <div className="modal-body">
            <div className="basic">
              {/* {this.props.data &&
                Object.keys(this.props.data).map((e) => {
                  return (
                    <p
                      style={{
                        margin: 4,
                        background: "#8080805e",
                        padding: 2,
                        fontSize: 12,
                      }}
                    >
                      <b>{e}</b>
                      {"  "}
                      <i>{this.props.data[e]}</i>
                    </p>
                  );
                })} */}
              <div className="instructions">
                <p></p>
              </div>
            </div>
          </div>

          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <form>
              <div className="group">
                <input
                  value={this.state.createdZone["name"]}
                  onChange={this.handleZoneName}
                  // placeholder={this.props.name}
                  type="text"
                  required="required"
                  // defaultValue={this.state.name}
                />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label> {this.props.selectedZone["createId"]} name</label>
              </div>
              {(this.props.selectedZone["id"] === "spots" ||
                this.props.selectedZone["id"] === "agency") && (
                <div className="group">
                  <input
                    value={this.state.createdZone["code"]}
                    onChange={this.handleZoneCode}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>Code</label>
                </div>
              )}
              {this.props.selectedZone["id"] === "agency" && (
                <div className="group">
                  <input
                    value={this.state.createdZone["ma_wallet"]}
                    onChange={this.handleZoneMAWallet}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label>MA Wallet</label>
                </div>
              )}
              {this.state[this.props.selectedZone["parentId"]] &&
                this.props.selectedZone["id"] !== "clusters" && (
                  <Dropdown
                    className="dd-cmdo"
                    title={`Select ${this.props.selectedZone["parentId"]}`}
                    items={this.state[this.props.selectedZone["parentId"]]}
                    searchable
                    onChange={this.handleZone}
                    selectionProp={this.state[
                      this.props.selectedZone["parentId"]
                    ].find(
                      (item) =>
                        item.name ===
                        this.state.createdZone[
                          this.props.selectedZone["parent"]
                        ]
                    )}
                  />
                )}
              {this.props.selectedZone["id"] === "spots" && (
                <Dropdown
                  className="dd-cmdo"
                  title={`User tag`}
                  items={userTags}
                  onChange={this.handleUserTagChange}
                  searchable={false}
                  reest={this.props.reset}
                  selectionProp={userTags.find(
                    (item) => item.name === this.state.createdZone["user_tag"]
                  )}
                />
              )}
              {this.props.selectedZone["id"] !== "clusters" &&
              this.props.selectedZone["id"] !== "regions" ? (
                <div className="group">
                  <input
                    value={this.state.createdZone["district"]}
                    onChange={this.handleDistrictChange}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label> Select District</label>
                </div>
              ) : (
                <Dropdown
                  className="dd-cmdo"
                  title={`Select division`}
                  items={divisions}
                  onChange={this.handleDivisionChange}
                  searchable
                  reest={this.props.reset}
                  selectionProp={divisions.find(
                    (item) => item.name === this.state.createdZone["division"]
                  )}
                />
              )}
              {(this.props.selectedZone["id"] === "agency" ||
                this.props.selectedZone["id"] === "spots") && (
                <div className="group">
                  <input
                    value={
                      this.state.createdZone["thana"]
                        ? this.state.createdZone["thana"]
                        : ""
                    }
                    onChange={this.handleThanaChange}
                    // placeholder={this.props.name}
                    type="text"
                    required="required"
                    // defaultValue={this.state.name}
                  />
                  <span className="highlight"></span>
                  <span className="bar"></span>
                  <label> Select Thana</label>
                </div>
              )}
            </form>
          </MuiPickersUtilsProvider>

          <Collapse in={this.state.errorMessages.length > 0}>
            <div className="error-container">
              {this.state.errorMessages.map((msg) => {
                return (
                  <p>
                    <b>{msg}</b> <i>is not filled up</i>
                  </p>
                );
              })}
            </div>
          </Collapse>

          <div className="footer">
            <BounceLoader
              className="loader"
              color={"#e2136e"}
              size={20}
              loading={this.state.loading}
            />

            {this.state.error_submitting && !this.state.loading ? (
              <span className="footer-error-msg">
                {/* {this.state.error_msg} */}
                Failed to add MDO
              </span>
            ) : null}

            <button className="button--cancel" onClick={this.hideModal}>
              {" "}
              Cancel{" "}
            </button>
            <button
              disabled={this.state.loading}
              className="button--save"
              onClick={this.submitForCreating}
            >
              {this.state.loading ? "Saving" : "Save"}
            </button>
          </div>
        </Modal>
      </section>
    );
  }
}

export default ManageModal;
